import { render, staticRenderFns } from "./SelectProductTypeView.vue?vue&type=template&id=071598fc&scoped=true&"
import script from "./SelectProductTypeView.vue?vue&type=script&lang=js&"
export * from "./SelectProductTypeView.vue?vue&type=script&lang=js&"
import style0 from "./SelectProductTypeView.vue?vue&type=style&index=0&id=071598fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071598fc",
  null
  
)

export default component.exports